import { render, staticRenderFns } from "./OverlayFunction.vue?vue&type=template&id=ae01cfa6&scoped=true"
import script from "./OverlayFunction.vue?vue&type=script&lang=js"
export * from "./OverlayFunction.vue?vue&type=script&lang=js"
import style0 from "./OverlayFunction.vue?vue&type=style&index=0&id=ae01cfa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae01cfa6",
  null
  
)

export default component.exports